export function isDateValid(dateStr: string): boolean {
  const date = new Date(dateStr)
  const isValidDateObj = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime())
  let isValidStringUsFormat = false
  let isValidStringCsFormat = false
  try {
    if (typeof dateStr === 'string' && dateStr.split('-')?.length === 3) {
      let isValid = true
      const dateParts = dateStr.split('-').map(s => Number(s))
      if (dateParts[0] < 1) {
        isValid = false
      }
      if (dateParts[1] < 1 || dateParts[1] > 12) {
        isValid = false
      }
      if (dateParts[2] < 1 || dateParts[2] > new Date(dateParts[0], dateParts[1], 0).getDate()) {
        isValid = false
      }
      isValidStringUsFormat = isValid
    }
    if (typeof dateStr === 'string' && dateStr.split('.')?.length === 3) {
      let isValid = true
      const dateParts = dateStr.split('.').map(s => Number(s))
      if (dateParts[2] < 1) {
        isValid = false
      }
      if (dateParts[1] < 1 || dateParts[1] > 12) {
        isValid = false
      }
      if (dateParts[0] < 1 || dateParts[0] > new Date(dateParts[2], dateParts[1], 0).getDate()) {
        isValid = false
      }
      isValidStringCsFormat = isValid
    }
  } catch (e) {
    isValidStringUsFormat = false
    isValidStringCsFormat = false
    console.warn(e)
  }
  return isValidDateObj && (isValidStringUsFormat || isValidStringCsFormat)
}

export function daysBetweenDates(first: Date, second: Date) {
  try {
    return Math.round((+second - +first) / (1000 * 60 * 60 * 24))
  } catch (e) {
    return 0
  }
}

export const wait = async (timeMs = 100) => {
  return new Promise(resolve => setTimeout(resolve, timeMs))
}
